export default __webpack_public_path__ + "static/media/github.0afb0e5d.svg";